import MaterialTable from 'material-table';
import React, { Component } from 'react';
import { forwardRef } from 'react';

import ArrowDownward from '@material-ui/icons/ArrowDownward';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Search from '@material-ui/icons/Search';

const tableIcons = {
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
};

class TablaMisCursos extends Component {
	constructor (props) {
		super(props);
		this.state = {
			columnasTablaMisCursos: [
				{ title: 'Curso', field: 'curso', render: rowData => <a href={rowData.url_curso} target="_blank">{rowData.curso}</a> },
				{ title: 'Grupo', field: 'grupo' },
				{ title: 'Nivel', field: 'nivel' },
				{ title: 'Estudiantes', field: 'estudiantes', render: rowData => <a onClick={() => this.handleClick(rowData.curso, rowData.grupo)}>{rowData.estudiantes}</a> }
			],
			dataTablaMisCursos: []
		};
	}

	componentDidMount = () => {
	}

	componentDidUpdate = (prevProps) => {
		if(prevProps != this.props){
			this.setState({dataTablaMisCursos: this.props.data.dataTablaMisCursos})
			if(prevProps.data.alumnosInfoEstatus != this.props.data.alumnosInfoEstatus){
				const columnasTablaMisCursos = this.state.columnasTablaMisCursos
				const estatusInfo = this.props.data.alumnosInfoEstatus
				for (const estatus of estatusInfo) {
					const estatusPasar =  { title : estatus, field: estatus }
					columnasTablaMisCursos.push(estatusPasar)
				}
				this.setState({ columnasTablaMisCursos : columnasTablaMisCursos})
			}
		}
	}

	handleClick = (curso, grupo, idCurso) => {
		const elemntoTablaCurso = document.getElementById('tablaCurso');
		elemntoTablaCurso.scrollIntoView({ behavior: 'smooth' });
		this.props.parentCallBack(curso, grupo, idCurso)
	}

	render() {
		return (
			<>
				{/* Validando BlackBoard*/}
				{ this.props.data.blackboard.isBlackboard === true ? (
					<div class="row">
						<div class="col-md-3"></div>
						<div class="col-md-6" style={{display: 'flex',  justifyContent:'center', alignItems:'center', height: '40vh'}}>
							<span>Próximamente para Blackboard</span>
						</div>
						<div class="col-md-3"></div>
					</div>
				):(
					<MaterialTable
						title=""
						icons={tableIcons}
						columns={ this.state.columnasTablaMisCursos }
						data={this.state.dataTablaMisCursos}     
						options={{
						headerStyle: {
							borderBottom: '2px solid #FF6F00',
						},
						rowStyle: {
							backgroundColor: '#f7f7f7',
						},
						draggable: false,
						pageSize: 10,
						pageSizeOptions: [10, 20],
						}}
						localization={{
						body: {
							emptyDataSourceMessage: 'Sin resultados'
						},
						toolbar: {
							searchTooltip: 'Buscar',
							searchPlaceholder: 'Buscar...',
							nRowsSelected: '{0} fila(s) seleccionada(s)'
						},
						pagination: {
							labelRowsSelect: 'filas',
							labelDisplayedRows: '{count} de {from}-{to}',
							firstTooltip: 'Primera página',
							previousTooltip: 'Página anterior',
							nextTooltip: 'Próxima página',
							lastTooltip: 'Última página'
						}
						}}
					/>
				)
				}
			</>
		);
	}
}

export default TablaMisCursos;